import { useNavigate } from 'react-router';

import { getEnvironmentConfig } from '@/lib/environment';

interface DevelopmentRouteProps {
  children: React.ReactNode;
}

export default function DevelopmentRoute({ children }: DevelopmentRouteProps) {
  const navigate = useNavigate();

  const { isProduction } = getEnvironmentConfig();

  if (isProduction) {
    navigate('/auth', { replace: true });
  }

  return <>{children}</>;
}
